import { ref as A, computed as S, openBlock as r, createElementBlock as g, createBlock as I, unref as a, withCtx as m, createElementVNode as l, createTextVNode as u, toDisplayString as k, createVNode as c, createCommentVNode as w, withModifiers as N, resolveDynamicComponent as W, resolveComponent as Q, onMounted as P, Transition as ee, inject as q, normalizeClass as F, Fragment as T, renderList as B, provide as G, watch as ne, onUnmounted as H, withKeys as J } from "vue";
import { CdrText as h, CdrLink as R, CdrButton as O, IconXSm as te, CdrAccordion as oe, CdrImg as se, CdrModal as ie, IconAccountProfile as Y, IconCheckSm as V, IconXLg as ae } from "@rei/cedar";
import { isWithinInterval as re } from "date-fns";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.reduce.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { tabbable as le } from "tabbable";
const de = [{
  modifier: "standalone",
  href: "/PurchaseHistoryView",
  rel: "nofollow",
  analyticsData: "login_module:purchase_history",
  dataUi: "login-module-purchase-history",
  innerHtml: "Purchase history"
}, {
  modifier: "standalone",
  href: "/account",
  analyticsData: "login_module:online_account",
  dataUi: "login-module-online-account",
  innerHtml: "Online account"
}, {
  modifier: "standalone",
  href: "/lists",
  analyticsData: "login_module:your_lists",
  dataUi: "login-module-your-lists",
  innerHtml: "Wish lists"
}, {
  modifier: "standalone",
  href: "/membership/mastercard?trackingId=account-widget",
  analyticsData: "login_module:mastercard",
  dataUi: "login-module-mastercard",
  innerHtml: '<span>REI Co-op<sup class="link__sup">&#174;</sup> Mastercard<sup class="link__sup">&#174;</sup></span>'
}], K = ["Speedier checkout", "Convenient order tracking", "Easier for members to earn and use Total REI Rewards"], X = [{
  class: "sign-in-nudge__flyout-registration-btn",
  modifier: "primary",
  action: "createAccount",
  text: "Create account",
  href: "/yaRegistration",
  data: null,
  analytics: "sign_in_nudge:create-account"
}, {
  class: "sign-in-nudge__flyout-login",
  modifier: "secondary",
  action: "login",
  text: "Sign in",
  href: "/login",
  data: "nav-level-1",
  analytics: "sign_in_nudge:login"
}], z = "/account/member-rewards", ce = "login_module:member moment rewards details", U = {
  pre: {
    start: /* @__PURE__ */ new Date("2026-02-23 00:00"),
    end: /* @__PURE__ */ new Date("2026-02-28 23:59")
  },
  post: {
    start: /* @__PURE__ */ new Date("2026-03-01 00:00"),
    end: /* @__PURE__ */ new Date("2026-03-23 23:59")
  }
}, ue = {
  start: /* @__PURE__ */ new Date("2026-02-24 00:00"),
  end: /* @__PURE__ */ new Date("2026-03-09 23:59")
}, L = () => ({
  sendClickAnalytics: (o) => {
    !window || !window.metrics || window.metrics.link(o);
  }
}), me = "America/Los_Angeles", _e = "en-US", fe = (n) => {
  if (!n)
    return null;
  const o = n.split("T")[0].split(/-/);
  return `${o[1]}/${o[2].trim("T")}/${o[0]}`;
}, j = (n) => {
  const o = new Date((/* @__PURE__ */ new Date()).toLocaleString(_e, {
    timeZone: me
  }));
  return re(o, n);
}, pe = (n, o = "America/Los_Angeles") => {
  const t = new Date((/* @__PURE__ */ new Date()).toLocaleString("en-US", {
    timeZone: o
  })), d = new Date(new Date(n).toLocaleString("en-US", {
    timeZone: o
  })) - t, _ = Math.ceil(d / (1e3 * 60 * 60 * 24));
  return _ >= 0 ? _ : 0;
}, ge = () => j(U.pre) || j(U.post);
const D = (n, o) => {
  const t = n.__vccOpts || n;
  for (const [s, d] of o)
    t[s] = d;
  return t;
}, ye = {
  class: "rewards-banner"
}, be = {
  __name: "RewardsDropBanner",
  setup(n) {
    const {
      sendClickAnalytics: o
    } = L(), t = A(pe(U.pre.end)), s = S(() => j(U.pre)), d = () => {
      o(ce);
    };
    return (_, e) => (r(), g("div", ye, [s.value ? (r(), I(a(h), {
      key: 0,
      class: "rewards-banner__banner-text"
    }, {
      default: m(() => [e[1] || (e[1] = l("span", null, "Rewards are almost here", -1)), u("—2025 Co-op Member Reward lands in " + k(t.value) + " " + k(t.value === 1 ? "day" : "days") + "! ", 1)]),
      _: 1
    })) : (r(), I(a(h), {
      key: 1,
      class: "rewards-banner__banner-text"
    }, {
      default: m(() => [e[3] || (e[3] = l("span", null, "2025 Co-op Member Rewards are here!", -1)), c(a(R), {
        href: a(z),
        class: "rewards-banner__link",
        onClick: e[0] || (e[0] = (y) => d())
      }, {
        default: m(() => e[2] || (e[2] = [u(" See your rewards details ")])),
        _: 1
      }, 8, ["href"])]),
      _: 1
    }))]));
  }
}, ve = /* @__PURE__ */ D(be, [["__scopeId", "data-v-8de8deb8"]]), we = "/rest/user/info", ke = () => {
  const n = A(null), o = async () => {
    try {
      const s = await fetch(we, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      });
      if (!s.ok)
        throw new Error(`Failed to fetch user info: ${s.status} ${s.statusText}`);
      const d = await s.json();
      n.value = d;
    } catch {
      n.value = null;
    }
  };
  return {
    isPrimaryMember: async () => {
      var s, d;
      return await o(), n.value ? ((s = n.value) == null ? void 0 : s.member) === !0 && ((d = n.value) == null ? void 0 : d.memberType) === "PRIMARY" : !1;
    }
  };
};
const he = {
  key: 1,
  "data-ui": "membership-info-rewards"
}, Ce = {
  class: "rewards-amount"
}, xe = {
  __name: "MembershipInfoRewardsDetails",
  props: {
    user: {
      type: Object,
      default: null
    },
    dividendBalance: {
      type: String,
      required: !0
    },
    shouldShowMessage: {
      type: Boolean,
      default: !1
    },
    rewardsMessage: {
      type: String,
      required: !0
    }
  },
  setup(n) {
    const {
      sendClickAnalytics: o
    } = L(), {
      isPrimaryMember: t
    } = ke(), s = S(() => t && ge()), d = (_) => {
      o({
        linkName: _
      });
    };
    return (_, e) => (r(), g("div", null, [n.user.membership.memberNumber ? (r(), I(a(h), {
      key: 0,
      "data-ui": "membership-info-number"
    }, {
      default: m(() => [u(" Member number: #" + k(n.user.membership.memberNumber), 1)]),
      _: 1
    })) : w("", !0), n.dividendBalance ? (r(), g("div", he, [c(a(h), {
      class: "member-rei-rewards"
    }, {
      default: m(() => [e[1] || (e[1] = u(" Total REI Rewards: ")), l("span", Ce, k(n.dividendBalance), 1)]),
      _: 1
    }), l("div", null, [c(a(R), {
      modifier: "standalone",
      href: "/account/member-rewards",
      "data-ui": "login-module-membership-details",
      onClick: e[0] || (e[0] = N((y) => d("login_module:your rewards activity"), ["stop"]))
    }, {
      default: m(() => e[2] || (e[2] = [u(" Your rewards activity ")])),
      _: 1
    })]), s.value ? (r(), I(ve, {
      key: 0
    })) : w("", !0), n.shouldShowMessage && !s.value ? (r(), I(a(h), {
      key: 1,
      class: "dividend-message"
    }, {
      default: m(() => [u(k(n.rewardsMessage), 1)]),
      _: 1
    })) : w("", !0)])) : w("", !0)]));
  }
}, Se = /* @__PURE__ */ D(xe, [["__scopeId", "data-v-7fc2e4c9"]]), Ie = {
  name: "MembershipInfo",
  components: {
    MembershipInfoRewardDetails: Se
  },
  props: {
    user: {
      type: Object,
      default: null
    },
    componentName: {
      type: String,
      default: "MembershipInfoRewardDetails"
    },
    dividendBalance: {
      type: String,
      required: !0
    },
    shouldShowMessage: {
      type: Boolean,
      default: !1
    },
    rewardsMessage: {
      type: String,
      required: !0
    }
  }
};
function $e(n, o, t, s, d, _) {
  return r(), g("div", null, [(r(), I(W(t.componentName), {
    user: t.user,
    "dividend-balance": t.dividendBalance,
    "should-show-message": t.shouldShowMessage,
    "rewards-message": t.rewardsMessage
  }, null, 8, ["user", "dividend-balance", "should-show-message", "rewards-message"]))]);
}
const Ne = /* @__PURE__ */ D(Ie, [["render", $e]]), Ae = {
  methods: {
    // Sends analytics click tracking event
    sendClickAnalytics(n) {
      !window || !window.metrics || window.metrics.link(n);
    }
  }
};
const Ee = {
  name: "MembershipLinksJoinAlready",
  components: {
    CdrLink: R
  },
  mixins: [Ae],
  props: {
    user: {
      type: Object,
      default: null
    }
  },
  methods: {
    sendAnalytics(n) {
      this.sendClickAnalytics({
        linkName: n
      });
    }
  }
}, Re = {
  key: 0,
  class: "become-member"
}, De = {
  class: "logout"
};
function Le(n, o, t, s, d, _) {
  const e = Q("CdrLink");
  return r(), g("div", null, [t.user && !t.user.membership ? (r(), g("div", Re, [c(e, {
    modifier: "standalone",
    class: "become-member--link",
    href: "/membership",
    onClick: o[0] || (o[0] = N((y) => _.sendAnalytics("login_module:join rei"), ["stop"]))
  }, {
    default: m(() => o[3] || (o[3] = [u(" Join REI ")])),
    _: 1
  }), o[6] || (o[6] = l("p", null, " Pay once and enjoy a lifetime of benefits, including FREE standard shipping, 10% back on eligible purchases and more – just for members. ", -1)), l("p", null, [o[5] || (o[5] = l("span", null, " Already a member? ", -1)), c(e, {
    modifier: "standalone",
    href: "/account",
    "data-ui": "login-module-link-membership",
    onClick: o[1] || (o[1] = N((y) => _.sendAnalytics("login_module:link your membership to your online account"), ["stop"]))
  }, {
    default: m(() => o[4] || (o[4] = [u(" Link your membership to your online account ")])),
    _: 1
  })])])) : w("", !0), l("div", De, [c(e, {
    modifier: "standalone",
    href: "/youraccount/logout",
    class: "link_stag track-link js-sign-out-sso-action",
    "data-analytics-id": "login_module:sign_out",
    "data-ui": "login-module-sign-out",
    onClick: o[2] || (o[2] = N((y) => _.sendAnalytics("login_module:sign_out"), ["stop"]))
  }, {
    default: m(() => o[7] || (o[7] = [u(" Sign out ")])),
    _: 1
  })])]);
}
const Me = /* @__PURE__ */ D(Ee, [["render", Le], ["__scopeId", "data-v-63a594a1"]]);
const Te = {
  name: "MembershipLinks",
  components: {
    MembershipLinksJoinAlready: Me
  },
  props: {
    user: {
      type: Object,
      default: null
    },
    experience: {
      type: String,
      default: "control"
    },
    componentName: {
      type: String,
      default: "MembershipLinksJoinREI"
    }
  }
};
function Be(n, o, t, s, d, _) {
  return r(), I(W(t.componentName), {
    user: t.user,
    class: "membership-links"
  }, null, 8, ["user"]);
}
const Oe = /* @__PURE__ */ D(Te, [["render", Be], ["__scopeId", "data-v-fe987d4d"]]);
const Pe = {
  class: "expiring-rewards",
  "data-ui": "expiring-rewards"
}, Ue = {
  class: "expiring-rewards__text-container"
}, je = {
  __name: "ExpiringRewardsNotification",
  props: {
    expirationDate: {
      type: String,
      required: !0
    }
  },
  emits: ["closed", "notificationSeen"],
  setup(n, {
    emit: o
  }) {
    const {
      sendClickAnalytics: t
    } = L(), s = n, d = o, _ = S(() => fe(s.expirationDate)), e = () => {
      t({
        linkName: "login_module:notifications_view rewards details"
      }), d("notificationSeen"), window.location.assign(z);
    }, y = () => {
      t({
        linkName: "login_module:notifications_expiring rewards message_close"
      }), d("closed");
    };
    return ($, x) => (r(), g("div", Pe, [l("div", Ue, [c(a(h), {
      "data-ui": "expiring-rewards-date"
    }, {
      default: m(() => [x[1] || (x[1] = l("span", {
        class: "expiring-rewards__highlight"
      }, "Don’t lose your rewards!", -1)), u(" You have rewards expiring " + k(_.value) + ". ", 1), c(a(O), {
        class: "expiring-rewards__link",
        "data-ui": "expiring-rewards-link",
        modifier: "link",
        onClick: e
      }, {
        default: m(() => x[0] || (x[0] = [u(" View details ")])),
        _: 1
      })]),
      _: 1
    })]), c(a(O), {
      "icon-only": !0,
      "aria-label": "Close",
      "data-ui": "expiring-rewards-close",
      onClick: y
    }, {
      icon: m(() => [c(a(te), {
        "inherit-color": ""
      })]),
      _: 1
    })]));
  }
}, Fe = /* @__PURE__ */ D(je, [["__scopeId", "data-v-22d0d08a"]]);
const Ye = {
  key: 0,
  class: "notifications__counter"
}, He = {
  key: 0,
  class: "notifications__content"
}, qe = {
  key: 1,
  class: "notifications__no-alerts"
}, Ge = {
  __name: "AccountSidebarNotifications",
  props: {
    notifications: {
      type: Object,
      required: !0
    }
  },
  setup(n) {
    const {
      sendClickAnalytics: o
    } = L(), t = n, s = A(!1), d = A(!!localStorage.getItem("flyoutNotificationSeen")), _ = A(!!localStorage.getItem("hideExpiringRewardsNotification")), e = S(() => {
      const C = Object.values(t.notifications || {}).reduce((v, p) => v + (p ? 1 : 0), 0);
      return {
        quantity: C,
        showCounter: C && !d.value,
        showContent: C && !_.value
      };
    }), y = () => {
      localStorage.setItem("flyoutNotificationSeen", !0), window.dispatchEvent(new Event("flyoutNotificationSeen")), d.value = !0;
    }, $ = () => {
      o({
        linkName: s.value ? "login_module:notifications_expand" : "login_module:notifications_collapse"
      });
    }, x = () => {
      s.value && !d.value && y(), s.value = !s.value, $();
    }, E = () => {
      localStorage.setItem("hideExpiringRewardsNotification", !0), _.value = !0, y();
    };
    return P(() => {
      localStorage.removeItem("hideExpiringRewardsNotification"), e.value.showCounter && setTimeout(() => {
        s.value = !0;
      }, 250);
    }), (C, v) => (r(), I(a(oe), {
      id: "notifications",
      class: "notifications",
      level: "1",
      "border-aligned": !0,
      opened: s.value,
      "content-spacing": !0,
      "data-ui": "account-flyout-notifications",
      onAccordionToggle: x
    }, {
      label: m(() => [v[0] || (v[0] = l("span", {
        class: "notifications__header"
      }, "Notifications", -1)), e.value.showCounter ? (r(), g("span", Ye, k(e.value.quantity), 1)) : w("", !0)]),
      default: m(() => [c(ee, {
        mode: "out-in",
        name: "fade"
      }, {
        default: m(() => {
          var p, i;
          return [e.value.showContent ? (r(), g("div", He, [c(Fe, {
            "expiration-date": (i = (p = n.notifications) == null ? void 0 : p.expiringRewards) == null ? void 0 : i.expirationDate,
            onClosed: E,
            onNotificationSeen: y
          }, null, 8, ["expiration-date"])])) : (r(), g("div", qe, [c(a(h), null, {
            default: m(() => v[1] || (v[1] = [u("No new alerts")])),
            _: 1
          })]))];
        }),
        _: 1
      })]),
      _: 1
    }, 8, ["opened"]));
  }
}, Je = /* @__PURE__ */ D(Ge, [["__scopeId", "data-v-37910d11"]]);
const We = {
  class: "cobrand-offers"
}, Ve = {
  key: 0,
  class: "cobrand-offers__mastercard-promotion"
}, Ke = {
  class: "cobrand-offers__mastercard-promotion__heading"
}, Xe = {
  key: 0,
  class: "cobrand-offers__mastercard-promotion__image"
}, ze = {
  key: 1,
  class: "cobrand-offers__mastercard-promotion"
}, Ze = {
  class: "mastercard-promotion__text",
  "data-analytics-config": "exclude"
}, Qe = {
  __name: "AccountSidebarCobrandOffers",
  setup(n) {
    const {
      sendClickAnalytics: o
    } = L(), t = A(q("sidebarCobrandExperience")), s = A(q("isCobrandOffersPeriod")), d = S(() => s.value && (t.value === "variant-1" || t.value === "variant-2"));
    return (_, e) => (r(), g("section", We, [d.value ? (r(), g("div", Ve, [c(a(R), {
      href: "/membership/mastercard?trackingId=account-widget",
      tabindex: "-1",
      modifier: "standalone",
      onClick: e[0] || (e[0] = N((y) => a(o)("login_module:mastercard_heading_link"), ["stop"]))
    }, {
      default: m(() => e[4] || (e[4] = [l("span", null, [u("REI Co-op"), l("sup", {
        class: "link__sup"
      }, "®"), u(" Mastercard"), l("sup", {
        class: "link__sup"
      }, "®")], -1)])),
      _: 1
    }), l("span", Ke, [t.value === "variant-2" ? (r(), g("figure", Xe, [c(a(se), {
      src: "https://public.cloud-dam.rei.com/api/public/content/24872137_limited-time-offer-credit-card.png",
      alt: "REI Credit card image"
    })])) : w("", !0), c(a(h), {
      class: "cobrand-offers__mastercard-promotion__title",
      tag: "h3"
    }, {
      default: m(() => e[5] || (e[5] = [u("A $130 value for you!")])),
      _: 1
    })]), c(a(h), {
      class: "cobrand-offers__mastercard-promotion__text"
    }, {
      default: m(() => [e[7] || (e[7] = u(" Get ")), e[8] || (e[8] = l("span", {
        class: "cobrand-offers__mastercard-promotion__text--bold"
      }, "$30 in card rewards", -1)), e[9] || (e[9] = l("sup", {
        class: "link__sup"
      }, "§", -1)), e[10] || (e[10] = u(" when you're approved for the REI Co-op")), e[11] || (e[11] = l("sup", {
        class: "link__sup"
      }, "®", -1)), e[12] || (e[12] = u(" Mastercard")), e[13] || (e[13] = l("sup", {
        class: "link__sup"
      }, "®", -1)), e[14] || (e[14] = u(" by Mar 9. Plus, you can ")), e[15] || (e[15] = l("span", {
        class: "cobrand-offers__mastercard-promotion__text--bold"
      }, "earn a $100 REI gift card", -1)), e[16] || (e[16] = u(" after your first non-REI purchase within 60 days from account opening.* Terms apply. ")), c(a(R), {
        href: "/membership/mastercard?trackingId=account-widget",
        "aria-label": "Learn more about the REI Co-op Mastercard",
        onClick: e[1] || (e[1] = N((y) => a(o)("login_module:mastercard_learn_more"), ["stop"]))
      }, {
        default: m(() => e[6] || (e[6] = [u("Learn more")])),
        _: 1
      })]),
      _: 1
    })])) : (r(), g("div", ze, [c(a(R), {
      class: "coopmastercard-brand",
      href: "/membership/mastercard?trackingId=account-widget",
      tabindex: "-1",
      modifier: "standalone",
      onClick: e[2] || (e[2] = N((y) => a(o)("login_module:mastercard_heading_link"), ["stop"]))
    }, {
      default: m(() => e[17] || (e[17] = [l("span", null, [u("REI Co-op"), l("sup", {
        class: "link__sup"
      }, "®"), u(" Mastercard"), l("sup", {
        class: "link__sup"
      }, "®")], -1)])),
      _: 1
    }), c(a(h), null, {
      default: m(() => [l("span", Ze, [e[19] || (e[19] = u(" Earn 5% in card rewards on all REI purchases—that's on top of your Co-op Member Reward earned on full-price items. Terms apply. ")), c(a(R), {
        href: "/membership/mastercard?trackingId=account-widget",
        "aria-label": "Learn more about the REI Co-op Mastercard",
        onClick: e[3] || (e[3] = N((y) => a(o)("login_module:mastercard_learn_more"), ["stop"]))
      }, {
        default: m(() => e[18] || (e[18] = [u("Learn more")])),
        _: 1
      })])]),
      _: 1
    })]))]));
  }
};
const en = {
  key: 0,
  class: "account-sidebar__customer-name",
  "data-ui": "login-module-user-name"
}, nn = {
  key: 1,
  class: "account-sidebar__membership-info--date"
}, tn = {
  key: 0,
  class: "account-sidebar__membership-info"
}, on = {
  class: "account-sidebar__links"
}, sn = {
  __name: "AccountSidebar",
  props: {
    user: {
      type: Object,
      default: null
    },
    open: {
      type: Boolean,
      default: !1
    },
    notifications: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["closed"],
  setup(n, {
    emit: o
  }) {
    const t = n, s = o, d = S(() => de.slice(0, -1)), _ = S(() => {
      var p;
      return (p = t.user) != null && p.contact ? `${t.user.contact.firstName} ${t.user.contact.lastName}` : null;
    }), e = S(() => {
      var p, i;
      return (i = (p = t.user) == null ? void 0 : p.membership) != null && i.memberJoinDate ? new Date(t.user.membership.memberJoinDate).getFullYear() : null;
    }), y = S(() => {
      var p, i;
      return ((i = (p = t.user) == null ? void 0 : p.membership) == null ? void 0 : i.dividendBalance) != null ? `$${parseFloat(t.user.membership.dividendBalance).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}` : null;
    }), $ = S(() => Object.keys(t.notifications).length !== 0), x = S(() => {
      var b;
      const p = /* @__PURE__ */ new Date(), i = p.getFullYear();
      return ((b = t.user) == null ? void 0 : b.membership) && p > /* @__PURE__ */ new Date(`01/01/${i}`) && p < /* @__PURE__ */ new Date(`02/14/${i}`);
    }), E = S(() => {
      const p = /* @__PURE__ */ new Date();
      return `Co-op Member Rewards earned on ${p.getFullYear() - 1} purchases will be available by March ${p.getFullYear()}.`;
    }), C = (p) => {
      var i;
      (i = window == null ? void 0 : window.metrics) == null || i.link({
        linkName: p
      });
    }, v = () => {
      s("closed");
    };
    return (p, i) => (r(), I(a(ie), {
      id: "account-sidebar",
      class: "account-sidebar",
      "data-ui": "account-sidebar",
      "content-class": "account-sidebar__modal-content",
      "wrapper-class": "account-sidebar__modal-container",
      "overlay-class": "account-sidebar__modal-overlay",
      label: "",
      opened: n.open,
      onClosed: v
    }, {
      title: m(() => [n.user && n.user.contact && _.value ? (r(), g("div", en, k(_.value), 1)) : w("", !0), n.user && n.user.membership && e.value ? (r(), g("div", nn, [l("span", null, "Member since " + k(e.value), 1)])) : w("", !0)]),
      default: m(() => {
        var b;
        return [n.user && n.user.membership ? (r(), g("div", tn, [n.user && n.user.membership ? (r(), I(Ne, {
          key: 0,
          user: n.user,
          "dividend-balance": y.value,
          "should-show-message": x.value,
          "rewards-message": E.value
        }, null, 8, ["user", "dividend-balance", "should-show-message", "rewards-message"])) : w("", !0)])) : w("", !0), l("div", on, [l("ul", {
          class: F(["account-links", "account-links--border", {
            "account-links--gutter": (b = n.user) == null ? void 0 : b.membership
          }])
        }, [(r(!0), g(T, null, B(d.value, (f) => (r(), g("li", {
          key: f
        }, [c(a(R), {
          class: "account-sidebar__link",
          "data-analytics-config": "exclude",
          modifier: f.modifier,
          href: f.href,
          rel: f.rel || null,
          "data-ui": f.dataUi,
          onClick: (M) => C(f.analyticsData),
          innerHTML: f.innerHtml
        }, null, 8, ["modifier", "href", "rel", "data-ui", "onClick", "innerHTML"])]))), 128))], 2), $.value ? (r(), I(Je, {
          key: 0,
          notifications: t.notifications
        }, null, 8, ["notifications"])) : w("", !0), c(Qe), c(Oe, {
          user: n.user,
          "component-name": "MembershipLinksJoinAlready"
        }, null, 8, ["user"])])];
      }),
      _: 1
    }, 8, ["opened"]));
  }
}, an = {
  ref: "account",
  "aria-live": "polite"
}, Mn = {
  __name: "MainComponent",
  props: {
    open: {
      type: Boolean,
      default: !1
    },
    user: {
      type: Object,
      default: null
    },
    sidebarCobrandExperience: {
      type: String,
      default: "control"
    },
    notifications: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["key-escape", "closed"],
  setup(n, {
    emit: o
  }) {
    const t = n, s = o, d = A(j(ue));
    G("sidebarCobrandExperience", t.sidebarCobrandExperience), G("isCobrandOffersPeriod", d);
    const _ = () => {
      s("closed");
    }, e = ({
      key: y
    }) => {
      t.open && (y === "Escape" || y === "Esc") && s("key-escape");
    };
    return ne(() => t.open, (y) => {
      var $, x, E;
      if (y) {
        const C = document.querySelector(".account-nav-button");
        d.value && !sessionStorage.getItem("10940abc") ? (($ = window == null ? void 0 : window.metrics) == null || $.link({
          linkName: "accflyout_mastercardlto_abctest"
        }), (x = window == null ? void 0 : window.metrics) == null || x.link({
          linkName: "login_module:open"
        }), sessionStorage.setItem("10940abc", !0), C && C.focus()) : ((E = window == null ? void 0 : window.metrics) == null || E.link({
          linkName: "login_module:open"
        }), C && C.focus());
      }
    }), P(() => document.addEventListener("keydown", e)), H(() => document.removeEventListener("keydown", e)), (y, $) => (r(), g("div", an, [c(sn, {
      open: n.open,
      user: n.user,
      notifications: n.notifications,
      onClosed: _
    }, null, 8, ["open", "user", "notifications"])], 512));
  }
};
const rn = {
  class: "account-nav-button__span-container"
}, ln = {
  key: 0,
  class: "account-nav-button__rewards-container",
  "data-visible": "desktop"
}, dn = {
  key: 1,
  class: "account-nav-button__rewards-container rewards-container-mobile",
  "data-visible": "mobile"
}, Tn = {
  __name: "AccountNavButton",
  props: {
    expiringRewards: {
      type: Object,
      default: null
    },
    userGreeting: {
      type: String,
      default: ""
    },
    rewardsBalance: {
      type: String,
      default: ""
    }
  },
  setup(n) {
    const o = n, t = A(!!localStorage.getItem("flyoutNotificationSeen")), s = S(() => o.expiringRewards && !t.value), d = () => {
      t.value = !!localStorage.getItem("flyoutNotificationSeen");
    }, _ = () => {
      var e;
      s.value && ((e = window == null ? void 0 : window.screen) == null ? void 0 : e.width) < 991 && (localStorage.setItem("flyoutNotificationSeen", !0), t.value = !0);
    };
    return P(() => {
      window.addEventListener("flyoutNotificationSeen", d);
    }), H(() => {
      window.removeEventListener("flyoutNotificationSeen", d);
    }), (e, y) => (r(), g("button", {
      id: "account-nav-button",
      class: F(["account-nav-button icon-button", {
        "account-nav-notification": s.value
      }]),
      "data-ui": "site-header-action-local-account",
      "data-count-label": "1",
      "data-count": "1",
      onClick: _
    }, [c(a(Y), {
      class: "gnav-icon account-nav-button__icon"
    }), l("div", rn, [c(a(h), {
      class: "account-nav-button__span",
      tag: "span",
      "data-visible": "desktop"
    }, {
      default: m(() => [u(k(n.userGreeting), 1)]),
      _: 1
    }), n.rewardsBalance ? (r(), g("div", ln, [y[0] || (y[0] = u(" Rewards: ")), c(a(h), {
      class: "account-nav-button__rewards-span",
      tag: "span",
      "data-visible": "desktop"
    }, {
      default: m(() => [u(k(n.rewardsBalance), 1)]),
      _: 1
    })])) : w("", !0), n.rewardsBalance ? (r(), g("div", dn, [c(a(h), {
      class: "account-nav-button__rewards-span--mobile",
      tag: "span"
    }, {
      default: m(() => [u(k(n.rewardsBalance), 1)]),
      _: 1
    })])) : w("", !0)])], 2));
  }
}, Z = () => {
  const n = (t, s) => {
    let d;
    if (s) {
      const _ = new URLSearchParams(s);
      return _.get("toUrl") && _.delete("toUrl"), _.get("storeId") && _.delete("storeId"), d = encodeURIComponent(`?${_.toString()}`), `/login?toUrl=${t}${d}`;
    }
    return `/login?toUrl=${t}`;
  };
  return {
    goToLogin: () => {
      if (!window || !window.location)
        return null;
      const {
        location: {
          pathname: t = "/",
          search: s
        }
      } = window;
      return n(t, s);
    }
  };
};
const cn = {
  class: "account-sign-in-link__text",
  "data-visible": "mobile"
}, un = {
  key: 1,
  class: "mobile-side-menu-nudge"
}, mn = {
  class: "sign-in-nudge__list"
}, _n = {
  class: "sign-in-nudge__list-items"
}, fn = {
  class: "sign-in-nudge__buttons"
}, pn = {
  __name: "AccountLink",
  props: {
    isMobileOnly: {
      type: Boolean,
      default: !1
    },
    linkText: {
      type: String,
      default: "Sign in"
    },
    mountingPointSelector: {
      type: String,
      default: null
    }
  },
  setup(n) {
    const {
      goToLogin: o
    } = Z(), {
      sendClickAnalytics: t
    } = L(), s = n, d = A(), _ = S(() => !s.isMobileOnly && !s.mountingPointSelector), e = (v) => {
      t({
        linkName: v.analytics
      }), window.location.href = o();
    }, $ = {
      login: e,
      createAccount: (v) => {
        t({
          linkName: v.analytics
        }), window.location.href = v.url;
      }
    }, x = (v, p) => {
      const i = $[v];
      i ? i(p) : console.warn(`no handler found for action: ${v}`);
    }, E = () => s.mountingPointSelector ? document.querySelector(s.mountingPointSelector) : null, C = () => {
      const v = E();
      v && (v.textContent = "", v.appendChild(d.value));
    };
    return P(() => {
      C();
    }), (v, p) => (r(), g("div", {
      ref_key: "accountLinkElement",
      ref: d
    }, [_.value ? (r(), I(a(R), {
      key: 0,
      class: "account-sign-in-link",
      "data-ui": "login-module-greeting",
      modifier: "standalone",
      "data-count-label": "1",
      "data-count": "1",
      onClick: p[0] || (p[0] = N((i) => e({
        url: "/login",
        analytics: "rei_nav:sign in"
      }), ["prevent"]))
    }, {
      default: m(() => [c(a(Y), {
        class: "gnav-icon account-sign-in-link--icon"
      }), l("div", cn, [c(a(h), {
        tag: "span"
      }, {
        default: m(() => p[1] || (p[1] = [u("SIGN IN")])),
        _: 1
      })]), c(a(h), {
        class: "account-sign-in-link--span",
        tag: "span",
        "data-visible": "desktop"
      }, {
        default: m(() => [u(k(n.linkText), 1)]),
        _: 1
      })]),
      _: 1
    })) : w("", !0), n.isMobileOnly ? (r(), g("div", un, [l("div", mn, [c(a(Y), {
      class: "sign-in-nudge__list-account-icon"
    }), p[2] || (p[2] = l("div", {
      class: "sign-in-nudge__list-title"
    }, [l("p", null, [l("strong", {
      class: "sign-in-nudge__text--strong"
    }, "SIGN IN"), u(" for the best experience: ")])], -1)), l("ul", _n, [(r(!0), g(T, null, B(a(K), (i) => (r(), g("li", {
      key: i,
      class: "sign-in-nudge__list-item"
    }, [c(a(V), {
      class: "sign-in-nudge__list-icon"
    }), u(k(i), 1)]))), 128))])]), l("div", fn, [(r(!0), g(T, null, B(a(X), (i, b) => (r(), I(a(O), {
      key: b,
      class: F(i.class),
      "data-ui": i.data,
      modifier: i.modifier,
      onClick: (f) => x(i.action, {
        url: i.href,
        analytics: i.analytics
      })
    }, {
      default: m(() => [u(k(i.text), 1)]),
      _: 2
    }, 1032, ["class", "data-ui", "modifier", "onClick"]))), 128))])])) : w("", !0)], 512));
  }
}, Bn = /* @__PURE__ */ D(pn, [["__scopeId", "data-v-48a32cdf"]]);
const gn = {
  class: "sign-in-nudge__flyout"
}, yn = {
  class: "sign-in-nudge__flyout-close"
}, bn = {
  class: "sign-in-nudge__list"
}, vn = {
  class: "sign-in-nudge__list-title"
}, wn = {
  class: "sign-in-nudge__list-items"
}, kn = {
  class: "sign-in-nudge__buttons"
}, hn = {
  __name: "SignInNudge",
  props: {
    open: {
      type: Boolean,
      default: !1
    },
    trapTabInsideWidget: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["key-escape", "closed"],
  setup(n, {
    emit: o
  }) {
    const {
      goToLogin: t
    } = Z(), {
      sendClickAnalytics: s
    } = L(), d = n, _ = o, e = A(), y = ({
      key: i
    }) => {
      d.open && (i === "Esc" || i === "Escape") && _("key-escape");
    }, $ = (i, b) => {
      if (!d.trapTabInsideWidget)
        return;
      const f = le(e.value), M = f.length - 1;
      if (f.length <= 1) {
        i.preventDefault();
        return;
      }
      b === "next" && i.target === f[M] && (i.preventDefault(), f[0].focus()), b === "back" && i.target === f[0] && (i.preventDefault(), f[M].focus());
    }, C = {
      login: (i) => {
        s({
          linkName: i.analytics
        }), window.location.href = t();
      },
      createAccount: (i) => {
        s({
          linkName: i.analytics
        }), window.location.href = i.url;
      }
    }, v = (i, b) => {
      const f = C[i];
      f ? f(b) : console.warn(`no handler found for action: ${i}`);
    }, p = (i) => {
      var b;
      (b = window == null ? void 0 : window.metrics) == null || b.link({
        linkName: i
      }), _("closed");
    };
    return P(() => {
      document.addEventListener("keydown", y);
    }), H(() => {
      document.removeEventListener("keydown", y);
    }), (i, b) => n.open ? (r(), g("div", {
      key: 0,
      id: "sign-in-nudge",
      ref_key: "signInNudgeContainer",
      ref: e,
      class: "sign-in-nudge",
      "data-ui": "sign-in-nudge",
      onKeydown: [b[1] || (b[1] = J(N((f) => $(f, "next"), ["exact"]), ["tab"])), b[2] || (b[2] = J(N((f) => $(f, "back"), ["shift"]), ["tab"]))]
    }, [l("div", gn, [l("div", yn, [c(a(O), {
      "icon-only": !0,
      "aria-label": "Close sign in nudge",
      class: "sign-in-nudge__close",
      type: "button",
      onClick: b[0] || (b[0] = N((f) => p("sign_in_nudge:close"), ["stop", "prevent"]))
    }, {
      default: m(() => [c(a(ae), {
        class: "cdr-button__icon",
        "inherit-color": ""
      }, {
        icon: m(() => b[3] || (b[3] = [])),
        _: 1
      })]),
      _: 1
    })]), l("div", bn, [l("div", vn, [c(a(h), null, {
      default: m(() => b[4] || (b[4] = [l("strong", {
        class: "sign-in-nudge__text--strong"
      }, "SIGN IN", -1), u(" for the best experience: ")])),
      _: 1
    })]), l("ul", wn, [(r(!0), g(T, null, B(a(K), (f) => (r(), g("li", {
      key: f,
      class: "sign-in-nudge__list-item"
    }, [c(a(V), {
      class: "sign-in-nudge__list-icon"
    }), u(k(f), 1)]))), 128))])]), l("div", kn, [(r(!0), g(T, null, B(a(X), (f, M) => (r(), I(a(O), {
      key: M,
      class: F(f.class),
      "data-ui": f.data || null,
      modifier: f.modifier,
      onClick: (Cn) => v(f.action, {
        url: f.href,
        analytics: f.analytics
      })
    }, {
      default: m(() => [u(k(f.text), 1)]),
      _: 2
    }, 1032, ["class", "data-ui", "modifier", "onClick"]))), 128))])])], 544)) : w("", !0);
  }
}, On = /* @__PURE__ */ D(hn, [["__scopeId", "data-v-a95b7876"]]);
export {
  Mn as AccountFlyout,
  Bn as AccountLink,
  Tn as AccountNavButton,
  On as SignInNudge
};
